function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.405 2.991a2.25 2.25 0 104.5 0 2.25 2.25 0 10-4.5 0zm6.585 11.126a1.5 1.5 0 00-.459-1.726 1.606 1.606 0 01-.579-.991 4.633 4.633 0 00-3.217-3.651l-3.281-.985A4.68 4.68 0 006.1 8.839l-.977 1.63a1.5 1.5 0 102.572 1.543l.978-1.63a1.682 1.682 0 011.917-.745l-4.1 11.6a1.5 1.5 0 102.829 1l1.981-5.603 2.754 5.754a1.5 1.5 0 102.705-1.3l-4.048-8.457.754-2.136.409.123a1.613 1.613 0 011.121 1.27 4.588 4.588 0 001.665 2.845 1.5 1.5 0 002.332-.621z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgWalkingFast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref);
}

export default SvgWalkingFast;